import { UniqueIdentifier } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { css } from '@emotion/react'
import { motion } from 'motion/react'
import { HTMLAttributes, useState } from 'react'

export default function AttachmentSortContainer({
	children,
	...props
}: HTMLAttributes<HTMLDivElement>) {
	const [isHover, setIsHover] = useState<boolean>(false)
	const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition } =
		useSortable({
			id: props.id as UniqueIdentifier,
		})

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	}

	const renderDragHandler = () => (
		<motion.div
			ref={setActivatorNodeRef}
			{...listeners}
			style={{
				top: -4,
				left: '50%',
				x: '-50%',
				transformOrigin: 'top center',
			}}
			initial={{
				opacity: 0,
				scale: 0.6,
			}}
			animate={{
				opacity: isHover ? 1 : 0,
				scale: isHover ? 1 : 0.6,
				transition: {
					type: 'spring',
					damping: 20,
					stiffness: 200,
				},
			}}
			whileHover={{
				scale: 1.05,
			}}
			css={css`
				position: absolute;
				z-index: 1;

				/* From https://css.glass */
				background: rgba(255, 255, 255, 0.2);
				border-radius: 16px;
				box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
				backdrop-filter: blur(5px);
				border: 1px solid rgba(255, 255, 255, 0.3);
				width: 30px;
				height: 10px;
				border-radius: 12px;

				cursor: grab;
			`}
		/>
	)

	return (
		<div
			onMouseOver={() => void setIsHover(true)}
			onMouseLeave={() => void setIsHover(false)}
			ref={setNodeRef}
			style={style}
			{...attributes}
			{...props}
			css={css`
				position: relative;
			`}
		>
			{renderDragHandler()}
			{children}
		</div>
	)
}
